import React, { useEffect, useState } from 'react';

// Components
import * as S from './Styled';
import Container from '../Container';
import Logo from '../Logo';
import { useMediaQuery } from 'react-responsive';
import Search from '../Search';
import Panel from './Panel';
import SideNav from './SideNav';
import ProfileNav from './ProfileNav';
import SearchModal from '../SearchModal';
import Placeholder from '../Placeholder';

// Store
import { useDispatch, useSelector } from 'react-redux';
import { TheBehaviorDrawer } from '../../actions/ui';
import {
  login,
  setMessage,
  setForgotData,
  forgotPassword,
  resetPassword,
} from '../../actions/auth';
import { profileNav } from '../../actions';
import { fetchGeoByIp } from '../../actions/user';

// Utils
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import toast from '../../utils/toast';
import { getValueStorage, setValueStorage } from '../../utils';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useVariables } from '../../context/variables';
import { Login, ForgotPassword, ResetPassword, Cart } from './modals';
import Location from '../Location';
import UserMenu from './components/UserMenu';
import CatMenuTriggerButton from '../CategoryMenu/CatMenuTriggerButton';
import { MenuOutlined } from '@ant-design/icons';

const Header = ({ layout, searchIsFoldable, ...props }) => {
  const [openedSearch, setOpenedSearch] = useState(false);
  const [cartIsVisible, setCartIsVisible] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { sideNav, profileNavIsVisible } = useSelector(state => state.ui);
  const location = useSelector(state => state.user.location);
  const isLoading = useSelector(state => state.user.isLoading);
  const cartSize = useSelector(state => state.cart.items.length);
  const isMob = useMediaQuery({ query: '(max-width: 767px)' });
  const [, setPreviewItem] = useState(null);
  const user = useSelector(state => state.auth);
  const { isAuthenticated } = user;
  const insurances = user.user != null && user.user.insurances;
  const history = useHistory();
  const params = queryString.parse(useLocation().search);
  const { logo } = { ...useVariables()?.theme };
  const [loginModal, setLoginModal] = useState(false);
  const [forgotModal, setForgotModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [cartModal, setCartModal] = useState(false);

  useEffect(() => {
    const setFirstInsurance = () => {
      if (isAuthenticated && getValueStorage('insurance_item') == null) {
        setValueStorage('insurance_item', insurances?.[0]);
      }
    };
    setFirstInsurance();
  }, [isAuthenticated, insurances]);

  useEffect(() => {
    dispatch(fetchGeoByIp());
  }, [dispatch]);

  useEffect(() => {
    if (!cartSize && cartIsVisible) {
      setCartIsVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartSize]);

  useEffect(() => {
    if (!isAuthenticated) {
      if (params.token && params.phone) {
        dispatch(
          setForgotData({
            token: params.token,
            phone: params.phone,
          })
        );
        setResetModal(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.phone, params.token]);

  useEffect(() => {
    if (!isMob) {
      if (sideNav) dispatch(TheBehaviorDrawer(false));
      if (profileNavIsVisible) dispatch(profileNav(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMob]);

  const handleDrawer = () => dispatch(TheBehaviorDrawer(!sideNav));

  const onSearch = state => setOpenedSearch(state);

  const onCart = event => {
    event.preventDefault();

    if (!cartSize) {
      return toast.info({
        message: t('messages.info.cart_is_empty'),
        placement: 'bottomRight',
      });
    }

    setCartModal(true);
  };

  const onLogin = async form => {
    try {
      const res = await dispatch(login(form));
      if (res) {
        setLoginModal(false);
        setForgotModal(false);
        history.push('/');
        if (isMob) {
          dispatch(TheBehaviorDrawer(false));
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onForgotPassword = async form => {
    try {
      const res = await dispatch(forgotPassword(form));
      if (res) {
        setForgotModal(false);
        setResetModal(true);
      }
    } catch (e) {
      console.error(e);
      dispatch(setMessage(null));
    }
  };

  const onResetPassword = async form => {
    try {
      const res = await dispatch(resetPassword(form));
      if (res) {
        setForgotData(null);
        history.push('/');
      }
    } catch (e) {
      console.error(e);
      setResetModal(false);
      setForgotData(null);
    }
  };

  return (
    <>
      <S.Header
        className={cn({
          'is-open': openedSearch,
        })}
        layout={layout}
      >
        <Container>
          <S.Content>
            <S.ToggleButton onClick={handleDrawer}>
              <S.Lines />
            </S.ToggleButton>
            {logo ? (
              <S.BrandLink to="/">
                <Logo
                  src={`/assets/svg/logo/${logo}.svg`}
                  alt={logo}
                  width="90"
                  height="48"
                />
              </S.BrandLink>
            ) : (
              <Placeholder style={{ width: 101 }} />
            )}

            <CatMenuTriggerButton
              className="header-trigger"
              id="cat-menu-trigger"
              icon={<MenuOutlined style={{ fontSize: 15 }} />}
              onToggleMenu={props.onToggleMenu}
              showMenu={props.showMenu}
              shortLabel={t('labels.catalog')}
            >
              {t('labels.catalog_products')}
            </CatMenuTriggerButton>

            <Location
              isLoading={isLoading}
              location={location}
              className="location_header"
            />

            <UserMenu />

            <SearchModal opened={openedSearch}>
              <Search
                placeholder={t('labels.search_for_medicines')}
                opened={openedSearch}
                onChangeVisible={onSearch}
                onCloseSearch={() => setOpenedSearch(false)}
                searchIsFoldable={searchIsFoldable}
              />
            </SearchModal>
            <Panel onCart={onCart} onLoginModal={() => setLoginModal(true)} />
          </S.Content>
        </Container>
      </S.Header>

      <SideNav
        onLoginModal={() => setLoginModal(true)}
        onOpenCart={() => setCartModal(true)}
        onToggleMenu={props.onToggleMenu}
        showMenu={props.showMenu}
      />
      <ProfileNav />

      <Login
        isLoading={isLoading}
        visible={loginModal}
        onOk={onLogin}
        onCancel={() => {
          if (!isLoading) {
            setLoginModal(false);
          }
        }}
        onRestore={() => {
          setLoginModal(false);
          history.push('?restore');
          setForgotModal(true);
        }}
      />

      <ForgotPassword
        isLoading={isLoading}
        visible={forgotModal}
        onOk={onForgotPassword}
        onCancel={() => {
          if (!isLoading) {
            dispatch(setMessage(null));
            setForgotModal(false);
            history.push('/');
          }
        }}
      />

      <ResetPassword
        isLoading={isLoading}
        visible={resetModal}
        onOk={onResetPassword}
        onCancel={() => {
          if (!isLoading) {
            setResetModal(false);
          }
        }}
      />

      <Cart
        isLoading={isLoading}
        visible={cartModal}
        onPreviewItem={setPreviewItem}
        onCancel={() => {
          if (!isLoading) {
            setCartModal(false);
          }
        }}
        setCartModal={setCartModal}
      />
    </>
  );
};

export default Header;
